import React from 'react';
import './styles.scoped.css';

const FormRadioField = ({
    label,
    required = false,
    error,
    errorMessage,
    disabled = false,
    options = [],
    value,
    onChange,
    name,
    className = '',
    style = {},
}) => (
    <div className={`form-radio-field ${className}`} style={style}>
        {label && (
            <label className={`label ${required ? 'required' : ''}`}>
                {label}
            </label>
        )}
        <div className="input-wrapper">
            <div className="radio-group">
                {options.map(option => (
                    <label
                        key={option.value}
                        className={`radio-label ${disabled ? (value === option.value ? 'radio-selected-disabled' : 'radio-disabled') : ''}`}
                    >
                        <input
                            className="radio-input"
                            type="radio"
                            name={name}
                            value={option.value}
                            checked={value === option.value}
                            onChange={onChange}
                            disabled={disabled}
                        />
                        <span className="radio-text">{option.label}</span>
                    </label>
                ))}
            </div>
            {error && errorMessage && (
                <span className="error-message">{errorMessage}</span>
            )}
        </div>
    </div>
);

export default FormRadioField;
